import React from 'react';
import { Link } from 'react-router-dom';
import { getAuth, signOut } from 'firebase/auth';
import { useState } from 'react';
import { HiMenu, HiX } from 'react-icons/hi'; // Using Heroicons from react-icons
import './Navbar.css'; // Make sure this file exists or we'll create it

function Navbar() {
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [showAdminDropdown, setShowAdminDropdown] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showVersionInfo, setShowVersionInfo] = useState(false);

  const handleSignOut = () => {
    const auth = getAuth();
    signOut(auth).catch((error) => {
      console.error('Error signing out.');
    });
  };

  // Version information
  const versionInfo = {
    appName: "Filesig Software Solutions Marketing",
    version: "1.1.0",
    buildDate: "2025-03-09",
  };

  return (
    <nav className="bg-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <div className="logo mr-3">
                <div className="logo-wrapper">
                  <span className="logo-text">file<span className="logo-highlight">sig</span></span>
                  <span className="logo-tagline">software solutions</span>
                </div>
              </div>
              <div className="text-2xl font-bold ml-2">Marketing</div>
            </Link>
          </div>
          
          <button
            className="md:hidden text-gray-800"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <HiX size={24} /> : <HiMenu size={24} />}
          </button>

          <div className="hidden md:flex items-center space-x-4">
            <div className="relative">
              <button
                onClick={() => setShowVersionInfo(!showVersionInfo)}
                className="px-3 py-2 rounded-md text-base font-medium text-gray-800 hover:bg-gray-100"
              >
                About
              </button>
              
              {/* Version Info Popup */}
              {showVersionInfo && (
                <div className="version-popup">
                  <div className="version-header">
                    <h3>Version Information</h3>
                    <button 
                      onClick={() => setShowVersionInfo(false)}
                      className="close-button"
                      aria-label="Close"
                    >
                      ×
                    </button>
                  </div>
                  <div className="version-content">
                    <p><strong>App:</strong> {versionInfo.appName}</p>
                    <p><strong>Version:</strong> {versionInfo.version}</p>
                    <p><strong>Build Date:</strong> {versionInfo.buildDate}</p>
                  </div>
                </div>
              )}
            </div>
          </div>

          {isMobileMenuOpen && (
            <div className="absolute top-16 left-0 right-0 bg-white p-4 md:hidden z-20 shadow-md">
              <button
                onClick={() => {
                  setShowVersionInfo(!showVersionInfo);
                  setIsMobileMenuOpen(false);
                }}
                className="block w-full text-left px-3 py-2 rounded-md text-base font-medium text-gray-800 hover:bg-gray-100"
              >
                About
              </button>

              {/* Mobile Version Info Popup */}
              {showVersionInfo && (
                <div className="mobile-version-popup">
                  <div className="version-header">
                    <h3>Version Information</h3>
                    <button 
                      onClick={() => setShowVersionInfo(false)}
                      className="close-button"
                      aria-label="Close"
                    >
                      ×
                    </button>
                  </div>
                  <div className="version-content">
                    <p><strong>App:</strong> {versionInfo.appName}</p>
                    <p><strong>Version:</strong> {versionInfo.version}</p>
                    <p><strong>Build Date:</strong> {versionInfo.buildDate}</p>
                    <p><strong>Environment:</strong> {versionInfo.environment}</p>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
